export const moderationRejectReasonsStatuses = {
    notEnoughFollowers: 'NOT_ENOUGH_FOLLOWERS',
    petIdNotFound: 'PET_ID_NOT_FOUND',
    petIdIncorrectPosition: 'PET_ID_INCORRECT_POSITION',
    userNotFound: 'USER_NOT_FOUND',
};
